.ai{justify-content:center;}